module.exports = __webpack_public_path__ + "img/pr-11.0b318cef.png";